import { Component, OnInit } from '@angular/core';
import { Title } from '@angular/platform-browser';
import { ActivatedRoute } from '@angular/router';
import { environment } from 'environments/environment';
import { Message } from 'primeng/api';
import { Subscription } from 'rxjs';
import { CommonBindingDataService } from '../../modules/shared/services/common-binding-data.service';
import { ErrorBindingService } from '../../modules/shared/services/error-binding.service';
import { SidebarService } from '../../modules/shared/services/sidebar.service';
import { UiService } from '../../modules/shared/services/ui.service';
import { AppSettings } from './../../modules/shared/app.settings';
import { NotificationsService } from './../../modules/shared/services/notifications.service';
import { StorageService } from './../../modules/shared/services/storage.service';
import { UserCommonService } from './../../modules/shared/services/user-common.service';

@Component({
  selector: 'app-sign-in',
  templateUrl: './sign-in.component.html'
})
export class SignInComponent implements OnInit {
  signInResponse: any;
  message: Message[] = [];
  otpId;
  forgotPopup = false;
  loginErrors = [{
    email: false,
    password: false,
  }];
  subscription: Subscription;
  isSubmitted = false;
  otpPopup = false;
  setPasswordPopup = false;
  isMetadataLoaded = false;
  otpEmail;
  otpPhone;

  signInWelcomeTextLabel;
  signInDescription;
  readMoreLabel;
  labelResetPassword;
  labelValidateOtp;
  signature;
  saml;
  isCompanyRole = false;
  poweredByBeforeLogoUrl = AppSettings.DEFAULT_POWERED_BY_LOGO_URL;
  logoPath = AppSettings.LOGIN_LOGO;

  constructor(
    private uiService: UiService,
    public signInService: UserCommonService,
    private storageService: StorageService,
    private commonBindingDataService: CommonBindingDataService,
    private sidebarService: SidebarService,
    private notificationService: NotificationsService,
    private errorBindingService: ErrorBindingService,
    private title: Title,
    private route: ActivatedRoute
  ) {
    this.title.setTitle(this.commonBindingDataService.getLabel('title_common'));
  }

  ngOnInit() {
    this.signInWelcomeTextLabel = this.commonBindingDataService.getLabel('label_sign_in_welcome_text');
    this.signInDescription = this.commonBindingDataService.getLabel('label_sign_in_description');
    this.readMoreLabel = this.commonBindingDataService.getLabel('label_read_more');
    this.labelResetPassword = this.commonBindingDataService.getLabel('label_reset_password');
    this.labelValidateOtp = this.commonBindingDataService.getLabel('label_validate_otp');
    this.signature = this.route.snapshot.queryParams.signature;
    this.saml = this.route.snapshot.queryParams.saml;

    const apiToken = this.storageService.getItemFromSessionStorage(AppSettings.TOKEN_KEY);
    if (apiToken !== undefined && apiToken !== null) {
      this.signInService.getUserProfile().subscribe(results => {
        this.storageService.setSessionStorage(AppSettings.USER_DETAILS, results);
        AppSettings.USER = results;
        this.notificationService.canFetchNotification = true;
        this.sidebarService.generateLeftMenuBar();
        this.setServiceAreaId();
      }, (error) => {
        this.errorBindingService.onAPIValidationError(error, this.loginErrors);
      });
    }
    if (this.saml == 'success' && this.signature) {
      this.doSSOSignIn(this.signature);
    }
  }

  setServiceAreaId() {
    this.signInService.getServiceAreaId().subscribe(result => {
      this.storageService.setSessionStorage('SERVICE_AREA_ID', result[0].id);
    });
  }

  doSignIn(signInData) {
    this.signInApiCall(signInData);
  }

  doSSOSignIn(signatureId) {
    this.ssoSignInApiCall(signatureId)
  }

  signInApiCall(signInData) {
    this.storageService.removeAll();
    this.storageService.clearSessionStorage();
    this.signInService.signIn(JSON.stringify(signInData)).subscribe(signInResult => {
      if (signInResult !== undefined && signInResult.sessionToken !== undefined) {
        this.signInResponse = signInResult;
        if (this.signInResponse.accessGroup !== null && this.signInResponse.accessGroup.length > 0) {
          this.notificationService.canFetchNotification = true;
          this.setSessionAndUserDetails(signInResult, 'fromAdmin');
          this.getUserMetaData();
        } else {
          this.message = [];
          this.message.push(
            {
              severity: 'error',
              summary: 'Error',
              detail: this.commonBindingDataService.getLabel('error_invalid_access_group')
            });
        }
      }
    }, (error) => {
      this.errorBindingService.onAPIValidationError(error, this.loginErrors);
    });
  }

  ssoSignInApiCall(signInAuthToken) {
    const signInData = {
      "loginAuthToken": signInAuthToken
    }
    this.signInService.ssoSignIn(JSON.stringify(signInData)).subscribe(signInResult => {
      if (signInResult !== undefined && signInResult.sessionToken !== undefined) {
        this.storageService.removeAll();
        this.storageService.clearSessionStorage();
        this.signInResponse = signInResult;
        if (this.signInResponse.accessGroup !== null && this.signInResponse.accessGroup.length > 0) {
          this.notificationService.canFetchNotification = true;
          this.setSessionAndUserDetails(signInResult, 'fromSSO');
          this.getUserMetaData('fromSSO');
        } else {
          this.message = [];
          this.message.push(
            {
              severity: 'error',
              summary: 'Error',
              detail: this.commonBindingDataService.getLabel('error_invalid_access_group')
            });
        }
      }
    }, (error) => {
      this.errorBindingService.onAPIValidationError(error, this.loginErrors);
    });
  }

  setSessionAndUserDetails(results, from) {
    this.storageService.setSessionStorage(AppSettings.TOKEN_KEY, results.sessionToken);
    this.storageService.setSessionStorage(AppSettings.SAVE_FILTERS, results.screenFilterList);
    this.storageService.setSessionStorage(AppSettings.USER_DETAILS, results.user);
    this.storageService.setSessionStorage(AppSettings.ACCESS_MENU, this.signInResponse.accessGroup);
    AppSettings.HEADER_AUTHORIZATION_VALUE = results.sessionToken;
    AppSettings.USER = results.user;
    if (from == 'fromAdmin') {
      this.storageService.setSessionStorage('loggedInUserType', 'adminUser');
    }
    this.storageService.setSessionStorage(AppSettings.ACCESS_MENU, this.signInResponse.accessGroup);
    if (results.user.userDetails !== null) {
      this.storageService.setSessionStorage(AppSettings.CURRENT_USER_CORPORATE_ID, results.user.userDetails.corporateId);
    }
  }

  setRolesAndGenerateSidebar() {
    const userDetails: any = this.storageService.getItemFromSessionStorage(AppSettings.USER_DETAILS);
    if (userDetails.roles[0].roleCode !== undefined && userDetails.roles[0].roleCode !== null) {
      AppSettings.LOGGED_IN_ROLE = userDetails.roles[0].roleCode;
      this.sidebarService.generateLeftMenuBar();
      this.uiService.profileUpdated();
    } else {
      this.storageService.removeAll();
      this.storageService.clearSessionStorage();
      const error = {
        general: [
          {
            message: this.commonBindingDataService.getLabel('label_invalid_role')
          }
        ]
      };
      this.errorBindingService.onAPIValidationError(error, this.loginErrors);
    }

    this.isSubmitted = false;
  }

  getUserMetaData(fromSSO?) {
    this.signInService.getUserMetaData().subscribe(result => {
      this.signInService.userMetaData = result;
      this.setServiceTypes(result.tenantServiceTypeList);
      this.setUserType(result.userTypeList);
      this.setServiceArea(result.tenantServiceAreaList);
      this.setBookingStatus(result.tourStatusConstants);
      this.setBookingStatusForFilter(result.tourStatusConstantsForFilter);
      this.storageService.setSessionStorage(AppSettings.TIME_SETTINGS, result.timeSettingsList);
      this.storageService.setSessionStorage(AppSettings.TENANT_CONFIG, result.tenantConfigKeys);
      this.storageService.setSessionStorage(AppSettings.TENANT_INFO, result.tenantInfo);
      this.storageService.setSessionStorage(AppSettings.TENANT_INFO, result.tenantInfo);
      this.storageService.setSessionStorage(AppSettings.PASSENGER_LIST_TYPE, result.passengerTypeList);
      this.setRolesAndGenerateSidebar();
      if (fromSSO == 'fromSSO') {
        window.location.href = environment.domainURL
        window.location.href = window.location.href.split('#')[0];
      }
      // setTimeout(() => {
      //   window.location.reload();
      // }, 100);
    }, (error) => {
      this.errorBindingService.onAPIValidationError(error, this.loginErrors);
    });
  }

  setBookingStatus(bookingStatus) {
    const bookingStatusArray = [];
    for (let status = 0; status < bookingStatus.length; status++) {
      bookingStatusArray.push({ label: bookingStatus[status].displayValue, value: bookingStatus[status].tourStatusCode });
    }
    this.storageService.setSessionStorage('BOOKING_STATUS', bookingStatusArray);
  }

  setBookingStatusForFilter(bookingStatusForFilter) {
    const bookingStatusForFilterArray = [{ label: this.commonBindingDataService.getLabel('label_all'), value: '' }];
    for (let status = 0; status < bookingStatusForFilter.length; status++) {
      bookingStatusForFilterArray.push({
        label: bookingStatusForFilter[status].displayValue,
        value: bookingStatusForFilter[status].tourStatusCode
      });
    }
    this.storageService.setSessionStorage('BOOKING_STATUS_FOR_FILTER', bookingStatusForFilterArray);
  }

  setServiceTypes(serviceTypes) {
    const serviceTypeArray: any[] = [
      { label: this.commonBindingDataService.getLabel('please_select'), value: '' },
    ];
    for (let type = 0; type < serviceTypes.length; type++) {
      serviceTypeArray.push({ label: serviceTypes[type].serviceType, value: serviceTypes[type].id });
    }
    this.storageService.setSessionStorage(AppSettings.SERVICE_TYPE, serviceTypeArray);
  }

  setUserType(userTypes) {
    const userTypeArray: any[] = [
      { label: this.commonBindingDataService.getLabel('please_select'), value: '' },
    ];
    for (let type = 0; type < userTypes.length; type++) {
      userTypeArray.push({ label: userTypes[type].roleName, value: userTypes[type].roleId });
    }
    this.storageService.setSessionStorage(AppSettings.USER_TYPE_LIST, userTypeArray);
  }

  setServiceArea(serviceAreas) {
    const serviceAreaArray: any[] = [{ label: this.commonBindingDataService.getLabel('please_select'), value: '' }];
    const serviceAreaAliasArray: any[] = [{ label: this.commonBindingDataService.getLabel('please_select'), value: '' }];
    const serviceAreaMapArray: any[] = [{ label: this.commonBindingDataService.getLabel('label_all_cities'), value: AppSettings.TENANT }];
    const multiSelectServiceArea: any[] = [];

    for (let area = 0; area < serviceAreas.length; area++) {
      serviceAreaArray.push({ label: serviceAreas[area].cityName, value: serviceAreas[area].id });
      serviceAreaMapArray.push({ label: serviceAreas[area].cityName, value: serviceAreas[area].id });
      serviceAreaAliasArray.push({ label: serviceAreas[area].cityAliasName, value: serviceAreas[area].id });
      multiSelectServiceArea.push({ label: serviceAreas[area].cityAliasName, value: serviceAreas[area].id });
    }
    this.storageService.setSessionStorage(AppSettings.SERVICE_AREA, serviceAreaArray);
    this.storageService.setSessionStorage(AppSettings.SERVICE_AREA_ALIAS, serviceAreaAliasArray);
    this.storageService.setSessionStorage(AppSettings.SERVICE_CITIES_MAP, serviceAreaMapArray);
    this.storageService.setSessionStorage(AppSettings.MUTLTI_SELECT_SERVICE_CITIES, multiSelectServiceArea);
  }

  moduleWiseRouteAccesses() {
    const groups = {};
    let accesses = this.signInResponse.accesses;
    for (let i = 0; i < accesses.length; i++) {
      const accessGroupName = accesses[i].accessGroupName;
      if (!groups[accessGroupName]) {
        groups[accessGroupName] = [];
      }
      groups[accessGroupName].push(accesses[i].accessName);
    }
    accesses = [];
    for (const accessGroupName in groups) {
      if (groups.hasOwnProperty(accessGroupName)) {
        accesses.push({ group: accessGroupName, accessName: groups[accessGroupName] });
      }
    }
    this.storageService.setSessionStorage(AppSettings.ACCESS_LIST, accesses);
  }

  uniqArray(arrArg) {
    return arrArg.filter((elem, pos, arr) => {
      return arr.indexOf(elem) === pos;
    });
  }

  forgotPassword() {
    this.forgotPopup = true;
  }

  onPopClose(event) {
    this.forgotPopup = false;
  }

  onOtpPopClose(event) {
    this.otpPopup = false;
  }

  onSetPasswordPopClose(event) {
    this.setPasswordPopup = false;
  }

  onOtpPopSave(event) {
    if (event.general !== undefined) {
      this.message = [];
      this.message.push({
        severity: 'error',
        summary: 'OTP',
        detail: event.general[0].message
      });
    } else {
      if (event.otpId) {
        this.otpId = event.otpId;
        this.message = [];
        this.message.push({
          severity: 'success',
          summary: 'OTP Verified',
          detail: 'OTP matched.'
        });
        this.setPasswordPopup = true;
      }
    }
    this.forgotPopup = false;
    this.otpPopup = false;
  }

  onPopSave(results) {
    this.otpEmail = results.email;
    this.otpPhone = results.phone;
    this.message = [];
    this.message.push({ severity: 'success', summary: 'Forgot Password.', detail: results.general[0].message });
    this.forgotPopup = false;
    this.otpPopup = true;
  }
}
